export enum FingerPosition {
  RightLittle = 'right little',
  RightRing = 'right ring',
  RightMiddle = 'right middle',
  RightIndex = 'right index',
  RightThumb = 'right thumb',
  LeftThumb = 'left thumb',
  LeftIndex = 'left index',
  LeftMiddle = 'left middle',
  LeftRing = 'left ring',
  LeftLittle = 'left little',
}

export interface FingerData {
  'data': string;
  'height': number;
  'impression-type': string;
  'position': FingerPosition;
  'quality': number;
  'view-count': number;
  'view-number': number;
  'width': number;
}

export interface BioDataBlock {
  'acquisition-level': number;
  'bits-per-pixel': number;
  'capture-device-id': number;
  'compression': string;
  'fingers': FingerData[];
  'horizontal-image-resolution': number;
  'horizontal-scan-resolution': number;
  'image-count': number;
  'scale-units': string;
  'version': string;
  'vertical-image-resolution': number;
  'vertical-scan-resolution': number;
}

export interface BioHeaderTemplate {
  'bio-subtype': number;
  'bio-type': number;
  'format-owner': number;
  'format-type': number;
  'finger': string | null;
}

export interface BioData {
  'type': string;
  'face-info': any;
}

export interface BioInfoTemplate {
  'bio-data-block': BioDataBlock | undefined;
  'bio-data': BioData | undefined;
  'bio-header-template': BioHeaderTemplate;
}

export interface FingerprintResponseData {
  'bio-info-templates': BioInfoTemplate[];
}
